<template>
  <van-dialog title="工单详情" v-model="show" :show-cancel-button="false" confirm-button-text="关闭" type="danger" class-name="pc-dialog pc-gg-dialog" @closed="$emit('onClose')">
    <div class="gd-list">
      <div class="gd-item">
        <div class="header-item">
          <div class="class">{{ gdInfo.CnClassName }}</div>
          <div class="status" :class="gdInfo.Status == 1 ? 'status1' : ''">{{ gdInfo.Status == 1 ? '已完成' : '待处理' }}</div>
        </div>
        <div class="time">{{ $TOOL.dateFormat(gdInfo.AddTime * 1000) }}</div>
        <div class="desc">{{ gdInfo.Desc }}</div>
      </div>
      <div class="takl-item" v-for="(item, index) in gdInfo.Talk" :key="index">
        <div v-if="item.WhereIs == 2" class="header img-cover">
          <img src="../../assets/images/kefu-icon.png" />
        </div>
        <div class="content-item">
          <div v-if="item.Type == 2" class="content img">
            <img :src="item.Content" />
          </div>
          <div v-else class="content">{{ item.Content }}</div>
          <div class="time">{{ $TOOL.dateFormat(item.AddTime * 1000) }}</div>
        </div>
        <div v-if="item.WhereIs == 1" class="user-header header img-cover">
          <img v-if="userInfo.Header" :src="userInfo.Header" />
          <img v-else src="../../assets/images/default-header.png" />
        </div>
      </div>
    </div>
    <div class="footer-item">
      <div class="input-item">
        <div class="input"><input v-model="Content" type="text" placeholder="请输入回复内容" /></div>
        <div class="btn" @click="handleSubmit">
          <van-loading v-if="submiting" color="#ffffff" />
          <span v-else>回复</span>
        </div>
      </div>
    </div>
  </van-dialog>
</template>


<script>

import { mapState } from 'vuex'
export default {
  emits: ['onClose'],
  name: "ContentGdDetailComponent",
  data() {
    return {
      show: false,
      id: '',
      Content: '',
      submiting: false,
      gdInfo: {}
    }
  },
  computed: {
    ...mapState(['userInfo', 'websiteInfo'])
  },
  methods: {
    open(data) {
      this.show = true
      this.id = data.Id
      this.handleGetGdDetail()
    },
    async handleGetGdDetail() {
      const { id } = this
      var res = await this.$API.addTickets.post({
        Switch: 4,
        Id: id
      })
      if (res.error == 0) {
        res.info.Img = res.info && res.info.Img ? res.info.Img.split(',') : []
        this.gdInfo = res.info
      }
    },
    handleSubmit() {
      const { Content } = this
      if (!Content) {
        this.$toast('请输入回复内容')
        return
      }
      this.handleSendTalk(Content, 1)
    },
    async handleSendTalk(content, type) {
      const params = {
        Switch: 2,
        Content: content,
        Type: type,
        GdId: this.id
      }
      this.submiting = true
      var res = await this.$API.addTickets.post(params)
      this.submiting = false
      if (res.error == 0) {
        if (type == 1) {
          this.Content = ''
        }
        this.$toast.success(res.info)
        this.handleGetGdDetail()
      } else {
        this.$dialog.alert({
          type: 'danger',
          className: 'pc-dialog',
          title: '提示',
          message: res.info,
          confirmButtonText: '确定',
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.van-dialog__content {
  padding: 0 !important;
}
.gd-list {
  height: calc(100vh - 360px);
  background-color: #f8f8f8;
  padding: 12px 15px;
  .gd-item {
    display: block;
    margin-bottom: 12px;
    padding: 12px;
    background-color: #fff;
    border-radius: 5px;
    color: #242941;
    .header-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      line-height: 20px;
      font-size: 14px;
      font-weight: bold;
      .class {
        flex: 1;
      }
      .status {
        color: #ff2442;
        &.status1 {
          color: #276eff;
        }
      }
    }
    .time {
      margin-top: 10px;
      color: #ccc;
      font-size: 12px;
      line-height: 17px;
    }
    .desc {
      margin-top: 12px;
      font-size: 14px;
      line-height: 20px;
    }
  }
  .takl-item {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 12px;
    .header {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      overflow: hidden;
      margin-right: 10px;
      background-color: #fff;
      &.user-header {
        margin-left: 10px;
        margin-right: 0;
      }
    }
    .content-item {
      flex: 1;
      padding: 12px;
      background-color: #fff;
      border-radius: 5px;
    }
    .content {
      line-height: 20px;
      font-size: 14px;
      font-weight: bold;
      color: #242941;
      &.img {
        width: 100%;
        height: auto;
        img {
          display: block;
          width: 100%;
          height: auto;
        }
      }
    }
    .time {
      margin-top: 6px;
      font-size: 12px;
      color: #ccc;
    }
  }
}
.footer-item {
  padding: 12px 15px;
  background-color: #fff;
  box-sizing: border-box;
  .input-item {
    width: 100%;
    height: 30px;
    border-radius: 5px;
    background-color: #eff2f8;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .input {
      flex: 1;
      padding: 0 10px;
    }
    .btn {
      cursor: pointer;
      width: 65px;
      height: 30px;
      border-radius: 5px;
      background: linear-gradient( 135deg, #58B7FF 0%, #276eff 100%);
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      font-size: 12px;
    }
  }
}
</style>